module.exports = __webpack_public_path__ + "img/bittrex-dark.b30a0a7b.png";